define(
  'app/views/product_sub_category_single_page_view',[
    'app/setup', 'app/collections/search_products', 'app/models/search_product',
    'app/views/search_view'
  ],
  function(takhfifan, searchProducts, searchProduct, searchView) {

  takhfifan.ProductSubCategorySinglePageView = takhfifan.SearchView.extend({
    events: {
      'click #tkhSearchButton' : 'updateQuery',
      'mouseleave .noUi-handle': 'updatePriceRange',
      'click .noUi-target': 'updatePriceRange',
      "change #tkhSearchCategories li div.checkbox input" : 'updateCategory',
      "change #tkhSearchBrands li div.checkbox input" : 'updateBrand',
      'keyup #search-field': 'updateQueryWithTimer'
    },

    template: ( $('#search-list-template').length > 0 ) ?
      _.template( $('#search-list-template').html() ) : '',

    render: function() {
      this.$(".tkh-search-deal-Wrapper").html(
        this.template({products:this.collection.toJSON()})
      );
    },
    
    updateQuery: function() {
      this.collection.fetch({reset: true});
    },

    initialize: function() {
      var _this = this;
      this.queryTimer = [];

      this.collection.q = this.$("#search-field").val();

      this.collection.bind('reset', this.render, this);
      this.collection.bind('error', this.render, this);
      this.currentUpperPrice=_this.$(".tkhUpperPriceValue").val();
      this.currentLowerPrice=_this.$(".tkhLowerPriceValue").val();
      this.collectionAbruptFetch=true;
    }
  });
});

